export default __webpack_public_path__ + "static/media/essentials-cover.9ba7eb45.webp";